import axios from "axios";
class AuthService {

  
    login(username: string|undefined, password: string|undefined,callback:any,errorCallback:any) {
      return axios
        .post(process.env.REACT_APP_USER_API + "Login/Authenticate", {
          UserName: username,
          Password : password
        })
        .then(response => {
          if (response.data.AccessToken) {
            localStorage.setItem("token", response.data.AccessToken);
          }
  
          callback();
        }).catch(error=>{
          if(error.code==='ERR_NETWORK')
          {
            errorCallback('A network error occured. Please check your network connection or try agin.')
          }
          else{
          errorCallback(error.response.data);
          }
        });
    }
  
    logout(callback:any) {
      localStorage.removeItem("token");
      callback();
    }

    

    getCurrentUser() {
        const token = localStorage.getItem("token");
        if (token){
          let jwtData = token.split('.')[1];
          let decodedJwtJsonData = window.atob(jwtData)
          let decodedJwtData = JSON.parse(decodedJwtJsonData)
           return decodedJwtData;

        }
    
        return null;
      }

      IsTokenValid(){
        const token = localStorage.getItem("token");
        if (token){
          let jwtData = token.split('.')[1]
          let decodedJwtJsonData = window.atob(jwtData)
          let decodedJwtData = JSON.parse(decodedJwtJsonData)
          let expiry=decodedJwtData.exp;
           if (Date.now() >= expiry * 1000) {
            return false;
          }
          return true;
        }
        return false;
      }

}

export default new AuthService();